import React, { useState, useEffect, useRef, useMemo } from 'react'; 
import ReactDOM from 'react-dom';
import { SocialIcon } from 'react-social-icons';
import logo from './logo_angelim.png';
import videoBackground from './video.mp4';
import agendaImg from './foto_culto.jpeg';
import pastoresImg from './pastores.png';
import cultoImg from './culto.jpg';
import Chatbot from './Chatbot';
import missaoVideo from './missao.mp4';
import videoJovens from './jovens.mp4';
import fundo from './fundo.mp3';
import jovensImg from './os_jovens.jpeg';
import jovensVideo from './jovensvideo.mp4';
import jovensjanVideo from './encontrojovens_jan.mp4';

/* >>> NOVO: logo instagram personalizado */
import instagramIcon from './instagram.png';

/* >>> NOVO: Agosto 2026 */
import gcHojeImg from './gc_oliveira_bairro.jpeg';
import atosLogo from './atos_logo.jpeg';

/* ------------------ Política de Privacidade (Modal) ------------------ */
function PrivacyPolicy() {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-white hover:text-red-600 text-sm underline-offset-2 hover:underline"
      >
        Política de Privacidade
      </button>
      {open && (
        <div className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center" aria-modal="true" role="dialog">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <div className="relative bg-white text-black w-full sm:max-w-3xl sm:rounded-2xl sm:shadow-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-5 sm:p-8">
              <div className="flex items-start justify-between gap-4">
                <h2 className="text-xl sm:text-2xl font-bold">Política Privacidade</h2>
                <button aria-label="Fechar" onClick={() => setOpen(false)} className="rounded-lg p-2 hover:bg-gray-100">✕</button>
              </div>
              <div className="mt-6 space-y-4 text-sm leading-relaxed">
                <p>
                  A Igreja Angelim Aveiro utiliza cookies temporários estatísticos gerais da utilização do website para fins internos de melhoria dos nossos serviços digitais e de comunicação. Estes cookies são, quando ativos, geridos pela plataforma Google Analytics e recolhem apenas dados gerais e não identificativos, como país/área geográfica, faixa etária ou tipo de dispositivo, aplicando-se a Política de Privacidade deste prestador, disponível em <a href="https://policies.google.com/privacy?hl=pt-PT" target="_blank" rel="noreferrer" className="text-red-700 underline">https://policies.google.com/privacy?hl=pt-PT</a>. Integrações de terceiros que habilitas no site, como o Google Maps ou partilhas para redes sociais, podem também definir cookies próprios segundo as respetivas políticas.
                </p>
                <p>
                  De acordo com os requisitos do RGPD e da legislação portuguesa aplicável, o nosso site informa previamente a utilização destes cookies estatísticos, permitindo a sua aceitação ou simples tomada de conhecimento. Qualquer outro dado facultado por telefone, formulário, plataforma de mensagens (Chatbot) ou e-mail será tratado exclusivamente para o fim de comunicação solicitado pelo utilizador (por exemplo, uma questão, pedido de contacto, marcação de presença ou donativo) e será guardado temporariamente pelo tempo estritamente necessário.
                </p>
                <p>
                  Mostramos no site textos públicos do nosso perfil de Instagram (@angelimaveiro). Esses conteúdos são obtidos através da plataforma Apify e armazenados de forma minimizada (texto e metadados essenciais) em JSONBin apenas para exibição no site. Não recolhemos dados pessoais dos visitantes para esta finalidade. As partilhas de eventos para Google Calendar, WhatsApp, e-mail ou Facebook apenas abrem ligações nos respetivos serviços, não mantendo registos desses dados no nosso sistema.
                </p>
                <p>
                  Nos termos da legislação aplicável, nomeadamente do Regulamento (UE) 2016/679 do Parlamento Europeu e do Conselho, de 27 de abril de 2016, e demais legislação nacional sobre proteção de dados, é garantido ao titular dos dados o direito de acesso, retificação, alteração, eliminação, limitação, oposição e portabilidade dos seus dados pessoais, mediante pedido escrito dirigido à entidade responsável.
                </p>
                <p>
                  Os pedidos podem ser enviados por correio ao cuidado de Igreja Angelim Aveiro, Rua da Quinta do Torto, 28, 3810-319 Santa Joana, Aveiro, Portugal, ou por correio eletrónico para <a href="mailto:angelimaveiro22@gmail.com" className="text-red-700 underline">angelimaveiro22@gmail.com</a>.
                </p>
                <p>
                  O titular dos dados pode, ainda, apresentar reclamação junto da Comissão Nacional de Proteção de Dados (CNPD), enquanto autoridade de controlo nacional. É também garantido ao titular, nos termos da lei, o direito de retirar o consentimento a qualquer momento, sem comprometer a licitude do tratamento efetuado com base no consentimento previamente dado.
                </p>
              </div>
              <div className="mt-6 flex justify-end">
                <button onClick={() => setOpen(false)} className="px-4 py-2 rounded-lg bg-black text-white hover:bg-red-600 transition-colors">
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
/* --------------------------------------------------------------------- */

const TZ = 'Europe/Lisbon';
const ADDRESS = 'Rua da Quinta do Torto, 28, 3810-319 Santa Joana, Aveiro';


/* ---------------------- Helpers de calendário/partilha ---------------------- */
function toTwo(n) {
  if (typeof n !== 'number') return n;
  return n < 10 ? `0${n}` : `${n}`;
}
function addMinutes(d, mins) { return new Date(d.getTime() + mins * 60000); }
function toGoogleDateUTC(d) { return new Date(d).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z'); }
function icsForEvent({ title, start, end, location, description }) {
  const dtStamp = toGoogleDateUTC(new Date());
  const dtStart = toGoogleDateUTC(start);
  const dtEnd = toGoogleDateUTC(end);
  return [
    'BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Igreja Angelim Aveiro//Agenda//PT','CALSCALE:GREGORIAN','METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${Date.now()}@angelimaveiro`,
    `DTSTAMP:${dtStamp}`,
    `DTSTART:${dtStart}`,
    `DTEND:${dtEnd}`,
    `SUMMARY:${title}`,
    `LOCATION:${location}`,
    `DESCRIPTION:${description || ''}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');
}
function downloadICS(ev, filename = 'evento.ics') {
  const ics = icsForEvent(ev);
  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
function buildShareLinks({ title, start, location, description }) {
  const dateText = start.toLocaleString('pt-PT', { timeZone: TZ, weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  const txt = `${title}\n${dateText}\n${location}${description ? `\n\n${description}` : ''}`;
  const enc = encodeURIComponent(txt);
  return {
    whatsapp: `https://wa.me/?text=${enc}`,
    email: `mailto:?subject=${encodeURIComponent(title)}&body=${enc}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://angelimaveiro.pt')}&quote=${enc}`,
    copyText: txt,
  };
}
function buildGoogleCalendarLink({ title, start, end, location, description }) {
  const st = toGoogleDateUTC(start);
  const en = toGoogleDateUTC(end);
  const q = new URLSearchParams({ action: 'TEMPLATE', text: title, dates: `${st}/${en}`, details: description || '', location }).toString();
  return `https://calendar.google.com/calendar/render?${q}`;
}
/* --------------------------------------------------------------------------- */

/* ------------------------- VLibras (Acessibilidade) ------------------------- */
const VLibras = () => {
  const mountEl = useMemo(() => {
    const el = document.createElement('div');
    el.id = 'vlibras-root';
    return el;
  }, []);
  useEffect(() => {
    document.body.appendChild(mountEl);
    const existing = document.getElementById('vlibras-plugin');
    const ensureInit = () => {
      try {
        if (window.VLibras && !window.__vlibrasLoaded) {
          new window.VLibras.Widget('https://vlibras.gov.br/app');
          window.__vlibrasLoaded = true;
        }
      } catch {}
    };
    if (!existing) {
      const script = document.createElement('script');
      script.id = 'vlibras-plugin';
      script.src = 'https://vlibras.gov.br/app/vlibras-plugin.js';
      script.defer = true;
      script.onload = ensureInit;
      document.body.appendChild(script);
    } else {
      ensureInit();
    }
    return () => {
      try { document.body.removeChild(mountEl); } catch {}
    };
  }, [mountEl]);
  const ui = (
    <div vw="true" className="enabled" style={{ zIndex: 2147483647 }}>
      <div vw-access-button="true" className="active"></div>
      <div vw-plugin-wrapper="true">
        <div className="vw-plugin-top-wrapper"></div>
      </div>
    </div>
  );
  return ReactDOM.createPortal(ui, mountEl);
};
/* --------------------------------------------------------------------------- */

const IgrejaAngelimAveiro = () => {
  const [activePage, setActivePage] = useState('Início');
  const [showMenu, setShowMenu] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [reflection, setReflection] = useState({
    text: 'E ele lhes ensinava muitas coisas por parábolas, e, no seu ensino, dizia: Ouvi! Eis que o semeadora saiu a semear.\n\nJesus conta a parábola do semeadora para nos mostrar que a mesma Palavra pode produzir resultados diferentes. O problema não está na semente, mas no coração que a recebe.\n\nPodemos ouvir sermões, ler a Bíblia e continuar iguais se não permitirmos que a Palavra crie raízes na nossa vida.\n\nJesus não procura apenas ouvintes, mas discípulos que dão fruto.',
    reference: 'Marcos 4:3-9',
    date: new Date().toISOString(),
    postDate: null,
    hasRealContent: true,
  });
  const [loading, setLoading] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [lastCheckedPost, setLastCheckedPost] = useState(null);
  const audioRef = useRef(null);

  /* --------------------------- Popup GC de hoje --------------------------- */
  const gcPopupStart = new Date('2026-08-18T00:00:00+01:00');
  const gcPopupEnd = new Date('2026-08-18T21:00:00+01:00');

  const [showGcPopup, setShowGcPopup] = useState(() => {
    const now = new Date();
    return now >= gcPopupStart && now < gcPopupEnd;
  });

  useEffect(() => {
    const msUntilClose = gcPopupEnd.getTime() - Date.now();
    if (msUntilClose <= 0) {
      setShowGcPopup(false);
      return;
    }
    const timer = setTimeout(() => setShowGcPopup(false), msUntilClose);
    return () => clearTimeout(timer);
  }, []);
  /* ----------------------------------------------------------------------- */

  /* ------------------ Navegação SPA com History API ------------------ */
  const navigateTo = (pageName) => {
    setActivePage(pageName);
    setShowMenu(false);
    window.history.pushState({ internal: true, page: pageName }, '', window.location.pathname);
    if (typeof window !== 'undefined') window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const goHome = () => {
    setActivePage('Início');
    setShowMenu(true);
    window.history.pushState({ home: true }, '', window.location.pathname);
    if (typeof window !== 'undefined') window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  useEffect(() => {
    window.history.replaceState({ home: true }, '', window.location.pathname);
    const onPop = (e) => {
      if (e.state && e.state.page) {
        setActivePage(e.state.page);
        setShowMenu(false);
      } else {
        setActivePage('Início');
        setShowMenu(true);
      }
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  /* ------------------------------------------------------------------- */

  /* -------------------------- Música de fundo ------------------------- */
  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    const tryPlay = () => {
      a.play().catch(() => {
        const onFirstGesture = () => {
          a.play().catch(() => {});
          window.removeEventListener('pointerdown', onFirstGesture);
          window.removeEventListener('keydown', onFirstGesture);
        };
        window.addEventListener('pointerdown', onFirstGesture, { once: true, passive: true });
        window.addEventListener('keydown', onFirstGesture, { once: true });
      });
    };
    tryPlay();
  }, []);
  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    const shouldPlay = showMenu || !['Sobre Nós', 'Em direto'].includes(activePage);
    if (shouldPlay) a.play().catch(() => {});
    else a.pause();
  }, [activePage, showMenu]);
  /* ------------------------------------------------------------------- */

  /* ---------------- Instagram / Reflexão e Ação (Apify + JSONBin) --------------- */
  const APIFY_TOKEN = 'apify_api_SOQPXHUomxBUqk06zecv5Asd6HWxdL0EvvN4';
  const JSONBIN_URL = 'https://api.jsonbin.io/v3/b/68b0b9c143b1c97be92ea6d0';
  const JSONBIN_MASTER_KEY = '$2a$10$U.2cT0X3wcGOsCZDMpYjxOQYyTmBy9wwc7BfO';
  const INSTAGRAM_USERNAME = 'angelimaveiro';

  const KEYWORDS = ['#viverapalavra'];

  const sobreVideoRef = useRef(null);
  const [sobreMuted, setSobreMuted] = useState(true);
  const [openAddId, setOpenAddId] = useState(null);
  const [openShareId, setOpenShareId] = useState(null);
  const [openReflectionShare, setOpenReflectionShare] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth < 1024);
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    const onDown = (e) => {
      const isBtn = e.target.closest?.('[data-popover-btn]');
      const isPop = e.target.closest?.('[data-popover]');
      if (!isBtn && !isPop) {
        setOpenAddId(null); setOpenShareId(null); setOpenReflectionShare(false);
      }
    };
    const onEsc = (e) => {
      if (e.key === 'Escape') {
        setOpenAddId(null); setOpenShareId(null); setOpenReflectionShare(false);
      }
    };
    document.addEventListener('pointerdown', onDown, { passive: true });
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('pointerdown', onDown);
      document.removeEventListener('keydown', onEsc);
    };
  }, []);

  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    els.forEach((el) => el.classList.add('opacity-0', 'translate-y-6'));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('opacity-100','translate-y-0','transition-all','duration-700','ease-out','will-change-transform');
            e.target.classList.remove('opacity-0','translate-y-6');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [activePage, showMenu]);

  useEffect(() => {
    if (activePage === 'Sobre Nós' && sobreVideoRef.current) {
      const v = sobreVideoRef.current;
      (async () => {
        try { v.muted = false; await v.play(); setSobreMuted(false); }
        catch { v.muted = true; try { await v.play(); } catch {} setSobreMuted(true); }
      })();
    }
  }, [activePage]);
  const unmuteSobreVideo = async () => {
    const v = sobreVideoRef.current; if (!v) return;
    try { v.muted = false; await v.play(); setSobreMuted(false); } catch {}
  };

  const normalize = (s) =>
    (s || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

  const getAllTextsFromPost = (p) => {
    const captions = [
      p.caption,
      p.firstComment,
      ...(p.latestComments?.map((c)=>c?.text)||[]),
      p.alt,
      (p.hashtags||[])
        .map((h)=>(h?.startsWith('#')?h:`#${h}`))
        .join(' ')
    ].filter(Boolean);
    return captions;
  };

  const tryExtractFromAllTexts = (post) => {
    for (const t of getAllTextsFromPost(post)) {
      const ref = extractReflectionFromInstagram(t, post);
      if (ref) return ref;
    }
    return null;
  };

  const scrapInstagramApify = async () => {
    try {
      setLoading(true);
      const configs = [
        { startUrls: [`https://www.instagram.com/${INSTAGRAM_USERNAME}/`], resultsType: 'posts', resultsLimit: 50, searchType: 'user' },
        { usernames: [INSTAGRAM_USERNAME], resultsLimit: 50, addParentData: true },
        { directUrls: [`https://www.instagram.com/${INSTAGRAM_USERNAME}/`], scrapePostsUntilDate: new Date(Date.now() - 30*24*60*60*1000).toISOString(), resultsLimit: 50 },
      ];
      for (let i=0;i<configs.length;i++) {
        const response = await fetch('https://api.apify.com/v2/acts/apify~instagram-scraper/runs', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${APIFY_TOKEN}` },
          body: JSON.stringify(configs[i])
        });
        if (!response.ok) continue;
        const runData = await response.json();
        const success = await waitForRunCompletion(runData.data.id);
        if (success) return true;
      }
      return false;
    } catch {
      return false;
    } finally {
      setLoading(false);
    }
  };

  const waitForRunCompletion = async (runId) => {
    const maxWaitTime = 120000, checkInterval = 5000; let elapsedTime = 0;
    while (elapsedTime < maxWaitTime) {
      try {
        const statusResponse = await fetch(`https://api.apify.com/v2/actor-runs/${runId}?token=${APIFY_TOKEN}`);
        if (!statusResponse.ok) throw new Error('status');
        const statusData = await statusResponse.json();
        const status = statusData.data.status;
        const defaultDatasetId = statusData.data.defaultDatasetId;
        if (status === 'SUCCEEDED') {
          const success = await fetchRunResults(defaultDatasetId);
          return success;
        }
        if (['FAILED','ABORTED','TIMED_OUT'].includes(status)) return false;
        await new Promise((r)=>setTimeout(r,checkInterval));
        elapsedTime += checkInterval;
      } catch {
        return false;
      }
    }
    return false;
  };

  const fetchRunResults = async (datasetId) => {
    try {
      if (!datasetId) return false;
      const resultsResponse = await fetch(`https://api.apify.com/v2/datasets/${datasetId}/items?token=${APIFY_TOKEN}`);
      if (!resultsResponse.ok) throw new Error('results');
      const results = await resultsResponse.json();
      if (results.length > 0 && results[0].error) return false;
      if (results && results.length > 0) {
        const reflexaoPost = await findReflexaoPostApify(results);
        if (reflexaoPost) {
          const saved = await updateJSONBin(reflexaoPost);
          if (saved) { await fetchReflection(); return true; }
        }
      }
      return false;
    } catch {
      return false;
    }
  };

  const findReflexaoPostApify = async (posts) => {
    try {
      const normKeywords = KEYWORDS.map((k) => k.toLowerCase());
      const hasKeyword = (post) => {
        const hay = normalize(getAllTextsFromPost(post).join(' | '));
        return normKeywords.some((k) => hay.includes(k));
      };
      const getPostId = (p) => p.id || p.shortCode || p.url || `apify_${Date.now()}`;
      for (const post of posts) {
        if (!hasKeyword(post)) continue;
        const candidate =
          extractReflectionFromInstagram(post.caption || post.firstComment || '', post) ||
          tryExtractFromAllTexts(post);
        if (candidate && candidate.reflexao && candidate.reflexao !== '(sem legenda)') {
          const pid = getPostId(post);
          if (pid !== lastCheckedPost) setLastCheckedPost(pid);
          return candidate;
        }
      }
      return null;
    } catch {
      return null;
    }
  };

  const extractReflectionFromInstagram = (caption, postData = {}) => {
    try {
      const raw = (caption || '').replace(/@\w+/g, '');
      let fullText = raw.replace(/#[^\s#]+/g, '').trim();
      if (!fullText) return null;
      const patterns = [
        /["""']([^"""']+)["""'][\s\S]*?([1-3]?\s*[A-Za-zÀ-ÿ]+\s+\d+:\d+(?:-\d+)?(?:\s+[A-Z]{2,4})?)/i,
        /"([^"]+)"[\s\S]*?([1-3]?\s*[A-Za-zÀ-ÿ]+\s+\d+:\d+(?:\s+[A-Z]{2,4})?)/i,
        /^([^#\n\r]+?)[\s\S]*?([1-3]?\s*[A-Za-zÀ-ÿ]+\s+\d+:\d+(?:\s+[A-Z]{2,4})?)/i,
      ];
      let reference = null;
      for (const pattern of patterns) {
        const match = fullText.match(pattern);
        if (match) {
          reference = (match[2] || '').trim();
          if (match[1]) { fullText = match[1].trim(); }
          break;
        }
      }
      const postIso = postData.timestamp ? new Date(postData.timestamp).toISOString() : new Date().toISOString();
      return {
        id: postData.id || postData.shortCode || `apify_${Date.now()}`,
        reflexao: fullText,
        referencia: reference,
        data: postIso,
        postDate: postIso,
        timestamp: postData.timestamp ? new Date(postData.timestamp).getTime() : Date.now(),
        fonte: 'Instagram - @angelimaveiro (Apify)',
        hasRealContent: true,
        postUrl: postData.url || postData.displayUrl || null,
      };
    } catch {
      return null;
    }
  };

  const updateJSONBin = async (data) => {
    try {
      if (!data || !data.reflexao || data.reflexao === '(sem legenda)') return false;
      const response = await fetch(JSONBIN_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'X-Master-Key': JSONBIN_MASTER_KEY },
        body: JSON.stringify(data)
      });
      return response.ok;
    } catch {
      return false;
    }
  };

  const fetchReflection = async () => {
    try {
      const response = await fetch(JSONBIN_URL, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'X-Master-Key': JSONBIN_MASTER_KEY }
      });
      if (response.ok) {
        const data = await response.json();
        const r = data.record || data;
        if (!r || !r.reflexao || !r.hasRealContent || r.reflexao.trim() === '' || r.reflexao.trim() === '(sem legenda)') {
          return;
        }
        const isNew = r.timestamp !== lastUpdate;
        setReflection({
          text: r.reflexao,
          reference: r.referencia || null,
          date: r.data || new Date().toISOString(),
          postDate: r.postDate || r.data || null,
          hasRealContent: true
        });
        if (isNew) setLastUpdate(r.timestamp);
      }
    } catch {}
  };

  useEffect(() => {
    fetchReflection();
    const t0 = setTimeout(() => scrapInstagramApify(), 10000);
    const t1 = setInterval(() => scrapInstagramApify(), 30 * 60 * 1000);
    const t2 = setInterval(() => {
      const now = new Date();
      if (now.getHours() >= 8 && now.getHours() <= 22) scrapInstagramApify();
    }, 10 * 60 * 1000);
    return () => { clearTimeout(t0); clearInterval(t1); clearInterval(t2); };
  }, []);
  /* --------------------------------------------------------------------------- */

  /* ------------------------------- Agenda Agosto 2026 ------------------------------- */
  const agenda2026 = [
    {
      id: '2026-08-acamp',
      day: 2,
      weekday: 'Dom a Sáb',
      time: '02 a 08 Agosto',
      title: 'Acampamento dos Jovens • 120€ tudo incluído',
      start: new Date('2026-08-02T09:00:00Z'),
      durationMin: 60 * 24 * 6,
      highlight: true,
    },
    {
      id: '2026-08-encontro-jovens',
      day: 18,
      weekday: 'Terça',
      time: '19:30',
      title: 'Encontro de Jovens ATOS',
      start: new Date('2026-08-18T18:30:00Z'),
      durationMin: 120,
      youth: true,
    },
    {
      id: '2026-08-gc-ola-olb',
      day: '3ªs',
      weekday: 'Terças',
      time: '20:00',
      title: 'GC OlÃ / GC OLB',
      start: new Date('2026-08-04T19:00:00Z'),
      durationMin: 90,
    },
    {
      id: '2026-08-gc-eixo',
      day: '4ªs',
      weekday: 'Quartas',
      time: '20:00 / 20:30',
      title: 'GC Eixo (20h Oração | 20h30 Adoração e Palavra)',
      start: new Date('2026-08-05T19:00:00Z'),
      durationMin: 90,
    },
    {
      id: '2026-08-gc-boco',
      day: '5ªs',
      weekday: 'Quintas',
      time: '20:00',
      title: 'GC BOCO',
      start: new Date('2026-08-06T19:00:00Z'),
      durationMin: 90,
    },
    {
      id: '2026-08-gc-lv',
      day: '5ªs',
      weekday: 'Quintas',
      time: '20:30',
      title: 'GC LV',
      start: new Date('2026-08-06T19:30:00Z'),
      durationMin: 90,
    },
    {
      id: '2026-08-culto',
      day: 'Dom',
      weekday: 'Domingos',
      time: '10:30',
      title: 'Culto',
      start: new Date('2026-08-09T09:30:00Z'),
      durationMin: 120,
    },
  ].map((ev) => ({
    ...ev,
    end: addMinutes(ev.start, ev.durationMin),
    location: ADDRESS,
    description: 'Eventos da Igreja Angelim Aveiro',
  }));
  /* --------------------------------------------------------------------------- */

  /* ------------------------------- UI helpers -------------------------------- */
  const menuItems = [
    { name: 'Sobre Nós', description: 'Conhece-nos melhor' },
    { name: 'Cultos', description: 'Horários e programação' },
    { name: 'Em direto', description: 'Transmissões ao vivo' },
    { name: 'Jovens', description: 'Encontros dos Jovens' },
    { name: 'Reflexão e Ação', description: 'Palavra na Prática' },
    { name: 'Contacto', description: 'Onde estamos' },
  ];

  const ResponsiveHeader = () => (
    <div className="bg-black py-3 px-4 sm:px-6 lg:px-8 flex justify-between items-center sticky top-0 z-50" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
      <div className="flex items-center space-x-2 sm:space-x-4">
        <img
          src={logo}
          alt="Igreja Angelim Aveiro"
          className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 object-contain cursor-pointer"
          onClick={goHome}
        />
        <h1
          className="text-white text-sm sm:text-lg lg:text-xl font-bold cursor-pointer"
          onClick={goHome}
        >
          {isMobile ? 'Angelim' : 'Igreja Angelim Aveiro'}
        </h1>
      </div>
      {!isMobile ? (
        <div className="flex items-center space-x-4 lg:space-x-6">
          <button
            onClick={goHome}
            className="px-3 py-2 rounded-lg transition-colors text-sm lg:text-base text-white hover:text-red-600"
            aria-label="Voltar ao início"
            title="Voltar ao início"
          >
            Início
          </button>
          {menuItems.map((item) => (
            <button
              key={item.name}
              onClick={() => navigateTo(item.name)}
              className={`px-3 py-2 rounded-lg transition-colors text-sm lg:text-base ${activePage === item.name ? 'bg-red-600 text-white' : 'text-white hover:text-red-600'}`}
            >
              {item.name}
            </button>
          ))}
        </div>
      ) : (
        <div className="flex items-center space-x-2">
          <button
            onClick={() => setShowMobileMenu(!showMobileMenu)}
            className="text-white hover:text-red-600 transition-colors p-2"
            aria-label="Abrir menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
          </button>
        </div>
      )}
      {isMobile && showMobileMenu && (
        <div className="absolute top-full left-0 right-0 bg-black border-t border-red-600 z-50">
          <div className="py-2">
            <button
              onClick={() => { goHome(); setShowMobileMenu(false); }}
              className="w-full text-left px-4 py-3 transition-colors text-white hover:bg-red-600 hover:text-white"
            >
              <span className="inline-flex items-center gap-2">
                <span>Início</span>
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M9 18l6-6-6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </button>
            {menuItems.map((item) => (
              <button
                key={item.name}
                onClick={() => { navigateTo(item.name); setShowMobileMenu(false); }}
                className={`w-full text-left px-4 py-3 transition-colors ${activePage === item.name ? 'bg-red-600 text-white' : 'text-white hover:bg-red-600 hover:text-white'}`}
              >
                <span className="inline-flex items-center gap-2">
                  <span>{item.name}</span>
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M9 18l6-6-6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );

  const IconCalendar = ({ className = 'w-6 h-6' }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" strokeWidth="2" />
      <line x1="16" y1="2" x2="16" y2="6" strokeWidth="2" />
      <line x1="8" y1="2" x2="8" y2="6" strokeWidth="2" />
      <line x1="3" y1="10" x2="21" y2="10" strokeWidth="2" />
    </svg>
  );

  const PopoverPanel = ({ children, onClose }) => {
    const small = isMobile || (typeof window !== 'undefined' && window.innerWidth < 640);
    if (small) {
      return (
        <>
          <div className="fixed inset-0 bg-black/40 z-[9998]" onClick={onClose} />
          <div
            data-popover
            className="fixed left-0 right-0 bottom-0 bg-white text-black p-3 rounded-t-2xl shadow-2xl z-[9999]"
            style={{ paddingBottom: 'calc(16px + env(safe-area-inset-bottom))' }}
          >
            <div className="mx-auto max-w-md">{children}</div>
          </div>
        </>
      );
    }
    return (
      <div data-popover className="absolute right-0 mt-2 w-72 rounded-xl bg-white text-black shadow-2xl ring-1 ring-black/10 p-2 z-[9999]">
        {children}
      </div>
    );
  };

  const AddMenu = ({ ev, onClose }) => {
    const google = buildGoogleCalendarLink(ev);
    const fileName = `${ev.title.replace(/\s+/g, '-')}-${ev.start.toISOString().slice(0, 10)}.ics`;
    return (
      <PopoverPanel onClose={onClose}>
        <button
          className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100"
          onClick={() => window.open(google, '_blank')}
        >
          <img alt="" src="https://www.google.com/favicon.ico" className="w-5 h-5" />
          <span>Google calendar</span>
        </button>
        <button
          className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100"
          onClick={() => downloadICS(ev, fileName)}
        >
          <IconCalendar className="w-5 h-5" />
          <span>Outro calendário (ICS)</span>
        </button>
      </PopoverPanel>
    );
  };

  const ShareMenu = ({ payload, onClose }) => {
    const links = buildShareLinks(payload);
    const Item = ({ href, label }) => (
      <a
        className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100"
        href={href}
        target={href.startsWith('mailto:') ? '_self' : '_blank'}
        rel="noreferrer"
      >
        <SocialIcon url={href} style={{ width: 28, height: 28 }} />
        <span className="text-black">{label}</span>
      </a>
    );
    return (
      <PopoverPanel onClose={onClose}>
        <Item href={links.whatsapp} label="WhatsApp" />
        <Item href={links.email} label="Email" />
        <Item href={links.facebook} label="Facebook" />
      </PopoverPanel>
    );
  };

  const Title = ({ children }) => (
    <h1 className="reveal text-4xl sm:text-5xl font-extrabold text-white mb-2 sm:mb-3">
      {children}
    </h1>
  );

  /* ---------------------------------- Páginas --------------------------------- */
  const pages = {
    'Sobre Nós': {
      title: 'Sobre a Igreja Angelim Aveiro',
      content: (
        <div className="w-full bg-black">
          <div className="py-8 sm:py-12 lg:py-16 text-center">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
              <Title>Sobre Nós</Title>
              <p className="reveal text-sm sm:text-base text-white max-w-4xl mx-auto leading-relaxed">
                A Igreja Angelim Aveiro é uma comunidade de fé comprometida em amar a Deus e às pessoas,
                <span className="text-white font-semibold"> semeando amor e colhendo vidas</span> para o Reino de Deus.
              </p>
            </div>
          </div>
          <div className="max-w-6xl mx-auto px-4 sm:px-6 pb-8 sm:pb-10">
            <div className="reveal relative rounded-2xl overflow-hidden border-2 border-white shadow-2xl aspect-video lg:min-h-[70vh]">
              <video
                ref={sobreVideoRef}
                className="absolute inset-0 w-full h-full object-cover"
                src={missaoVideo}
                autoPlay
                muted={sobreMuted}
                loop
                playsInline
                controls
              />
              {sobreMuted && (
                <button
                  onClick={unmuteSobreVideo}
                  aria-label="Ligar som"
                  className="absolute inset-0 flex items-center justify-center"
                >
                  <span className="px-5 py-3 rounded-full bg-white/90 text-black font-semibold shadow-lg border border-black/10">Ligar som</span>
                </button>
              )}
            </div>
          </div>
          <div className="max-w-6xl mx-auto px-4 sm:px-6 pb-12">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="reveal border-2 border-white p-5 rounded-2xl text-white shadow-2xl">
                <h3 className="text-xl font-bold mb-3">VISÃO</h3>
                <p className="text-sm leading-relaxed">Ser uma comunidade apaixonada por conhecer profundamente a Cristo e torná-Lo conhecido em Aveiro, em Portugal e até aos confins da terra.</p>
              </div>
              <div className="reveal border-2 border-white p-5 rounded-2xl text-white shadow-2xl" style={{ transitionDelay: '120ms' }}>
                <h3 className="text-xl font-bold mb-3">MISSÃO</h3>
                <p className="text-sm leading-relaxed">Conduzir pessoas a um relacionamento vivo com Jesus Cristo, através do ensino da Palavra, da comunhão autêntica e do envio missionário, para que cada crente viva como discípulo e faça discípulos.</p>
              </div>
              <div className="reveal border-2 border-white p-5 rounded-2xl text-white shadow-2xl" style={{ transitionDelay: '240ms' }}>
                <h3 className="text-xl font-bold mb-3">VALORES</h3>
                <ul className="text-sm space-y-2">
                  <li><span className="font-semibold">Filiação:</span> viver como filhos amados, guiados pela graça.</li>
                  <li><span className="font-semibold">Comunhão:</span> corpo unido, fé visível no amor.</li>
                  <li><span className="font-semibold">Missão:</span> tornar Cristo conhecido em palavras e ações.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="max-w-6xl mx-auto px-4 sm:px-6 pb-12">
            <div className="flex flex-col lg:flex-row items-start gap-6 lg:gap-10">
              <div className="w-full lg:w-1/2 order-2 lg:order-1 reveal self-start">
                <div className="rounded-3xl border-4 border-white overflow-hidden shadow-2xl">
                  <img src={pastoresImg} alt="Pastores Pedro e Sandra Almeida" className="block w-full h-auto" />
                </div>
              </div>
              <div className="w-full lg:w-1/2 flex items-start justify-center lg:justify-start p-4 sm:p-6 lg:px-16 lg:pt-0 order-1 lg:order-2">
                <div className="max-w-2xl">
                  <h2 className="reveal text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-3 text-left">Os nossos pastores: Pedro e Sandra Almeida</h2>
                  <div className="space-y-3 text-white text-sm sm:text-base leading-relaxed text-left">
                    <p className="reveal">Os Pastores Pedro e Sandra Almeida são dedicados ao crescimento espiritual da comunidade e ao desenvolvimento de uma igreja saudável e relevante em Aveiro.</p>
                    <p className="reveal">Com uma paixão genuína pelo ministério, têm conduzido a Igreja Angelim Aveiro com sabedoria e amor, focando sempre em conhecer a Cristo e torná-Lo conhecido.</p>
                    <p className="reveal">Juntos, servem a comunidade de Aveiro, proporcionando ensino bíblico sólido, cuidado pastoral e uma visão clara para o crescimento da igreja. A sua liderança reflete o coração de Cristo e o desejo de ver cada pessoa a glorificar a Deus e a encontrar satisfação n'Ele para sempre. (1Co 10:31; Is 43:7)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    },

    Cultos: {
      title: 'Cultos e Horários',
      content: (
        <div className="min-h-dvh w-full bg-black">
          <div className="flex flex-col lg:flex-row min-h-dvh">
            <div className="w-full lg:w-1/2 flex flex-col order-2 lg:order-1">
              <div className="p-4 sm:p-6 flex items-center justify-center">
                <p className="reveal text-sm sm:text-base lg:text-lg text-white font-bold text-center leading-relaxed">
                  1 João 3:1 – "Vede que grande amor nos tem concedido o Pai: que fôssemos chamados filhos de Deus! E de facto somos!"
                </p>
              </div>
              <div className="reveal">
                <img src={cultoImg} alt="Igreja Angelim Aveiro" className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="w-full lg:w-1/2 flex flex-col p-4 sm:p-6 lg:p-16 order-1 lg:order-2">
              <div className="max-w-2xl w-full mx-auto lg:mx-0">
                <div className="mb-6 sm:mb-8 text-center">
                  <Title>Cultos</Title>
                </div>
                <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
                  <div className="reveal border-2 border-white p-4 sm:p-6 rounded-lg">
                    <h3 className="text-lg sm:text-xl font-bold text-white mb-3">Cultos de Domingo</h3>
                    <p className="text-sm sm:text-base text-white font-medium mb-2">Todos os Domingos às 10:30</p>
                    <p className="text-xs sm:text-sm text-white">Rua da Quinta do Torto, 28</p>
                    <p className="text-xs sm:text-sm text-white">3810-319 Santa Joana, Aveiro</p>
                  </div>
                  <div className="reveal border-2 border-white p-4 sm:p-6 rounded-lg">
                    <h3 className="text-lg sm:text-xl font-bold text-white mb-4">Grupos de Crescimento (GC)</h3>
                    <div className="space-y-4">
                      <div>
                        <p className="text-sm sm:text-base text-white font-medium mb-1">Terças-feiras às 20:00</p>
                        <p className="text-xs sm:text-sm text-white font-semibold">GC OIÃ • GC OLB</p>
                      </div>
                      <div>
                        <p className="text-sm sm:text-base text-white font-medium mb-1">Quartas-feiras</p>
                        <p className="text-xs sm:text-sm text-white font-semibold">GC Eixo • 20:00 (Oração) | 20:30 (Adoração e Palavra)</p>
                        <p className="text-xs text-gray-300">Rua do Outeiro 57, 3880-794, Eixo</p>
                      </div>
                      <div>
                        <p className="text-sm sm:text-base text-white font-medium mb-1">Quintas-feiras às 20:00</p>
                        <p className="text-xs sm:text-sm text-white font-semibold">GC BOCO</p>
                      </div>
                      <div>
                        <p className="text-sm sm:text-base text-white font-medium mb-1">Quintas-feiras às 20:30</p>
                        <p className="text-xs sm:text-sm text-white font-semibold">GC LV</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    },

    Jovens: {
      title: 'Jovens Angelim',
      content: (() => {
        const isYouth = (s = '') => /(jovens?|adolescentes?|youth|acampamento)/i.test(s);
        const youthEvents = agenda2026
          .filter(ev => isYouth(ev.title))
          .sort((a, b) => a.start - b.start)
          .slice(0, 4);

        const videos = [
          { id: 'vj-1', src: videoJovens,     label: 'Acampamento Jovens 2025' },
          { id: 'vj-2', src: jovensVideo,     label: 'Encontro de Jovens, Julho 2025' },
          { id: 'vj-3', src: jovensjanVideo,  label: 'Encontro de Jovens, Janeiro 2025' },
        ];

        const pilares = [
          { letra: 'A', palavra: 'Amar' },
          { letra: 'T', palavra: 'Transformar' },
          { letra: 'O', palavra: 'Obedecer' },
          { letra: 'S', palavra: 'Servir' },
        ];

        return (
          <div className="bg-black">
            <div className="relative w-full min-h-[60vh] sm:min-h-[68vh] overflow-hidden flex items-center">
              <img
                src={jovensImg}
                alt=""
                className="absolute inset-0 w-full h-full object-cover scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/60 to-black" />

              <div className="relative z-10 w-full max-w-6xl mx-auto px-5 sm:px-8 py-14">
                <div className="flex flex-col items-center text-center gap-5">
                  <div className="rounded-3xl overflow-hidden ring-1 ring-white/15 shadow-[0_20px_60px_-15px_rgba(239,68,68,0.45)] w-24 h-24 sm:w-32 sm:h-32 lg:w-36 lg:h-36 shrink-0">
                    <img
                      src={atosLogo}
                      alt="ATOS: Amar • Transformar • Obedecer • Servir"
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div>
                    <span className="inline-block text-[11px] sm:text-xs tracking-[0.3em] uppercase text-red-500 font-semibold mb-3">
                      Ministério de Jovens
                    </span>
                    <h1 className="text-white text-4xl sm:text-6xl lg:text-7xl font-black tracking-tight leading-[0.95]">
                      ATOS
                    </h1>
                    <p className="mt-4 text-white/70 text-sm sm:text-base max-w-xl mx-auto leading-relaxed">
                      Uma geração que vive a Palavra em Aveiro.
                    </p>
                  </div>

                  <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mt-2">
                    {pilares.map(p => (
                      <span
                        key={p.letra}
                        className="inline-flex items-center gap-2 rounded-full bg-white/[0.07] border border-white/10 backdrop-blur px-4 py-2 text-white/90 text-xs sm:text-sm"
                      >
                        <span className="text-red-500 font-black">{p.letra}</span>
                        <span className="font-medium">{p.palavra}</span>
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12 sm:py-16 space-y-14 sm:space-y-20">
              <section className="reveal grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
                <div className="lg:col-span-7">
                  <span className="text-[11px] tracking-[0.25em] uppercase text-red-500 font-semibold">
                    Quem somos
                  </span>
                  <h2 className="text-white text-2xl sm:text-4xl font-bold mt-3 mb-5 leading-tight">
                    Uma família que cresce junta
                  </h2>
                  <div className="space-y-4 text-white/70 leading-relaxed text-sm sm:text-base">
                    <p>
                      Somos adolescentes e jovens adultos que amam Jesus e a Sua Palavra. Crescemos
                      juntos em amizade, discipulado e serviço, e em cada encontro dedicamos tempo
                      à Bíblia e à oração.
                    </p>
                    <p>
                      Se procuras um lugar para pertencer, ser desafiado a <em className="text-white not-italic font-medium">Viver a Palavra</em> e
                      descobrir o propósito de Deus, vem estar connosco.
                    </p>
                  </div>
                </div>

                <div className="lg:col-span-5 w-full">
                  <figure className="relative rounded-2xl bg-gradient-to-br from-red-600/15 to-transparent border border-red-600/25 p-6 sm:p-7">
                    <div className="text-red-500/40 text-5xl leading-none font-serif mb-1">"</div>
                    <blockquote className="text-white text-base sm:text-lg font-medium leading-relaxed">
                      Jovens, eu escrevi a vocês, porque são fortes, e em vocês a Palavra de Deus permanece.
                    </blockquote>
                    <figcaption className="mt-4 text-red-500 text-xs sm:text-sm font-semibold tracking-wide">
                      1 João 2:14
                    </figcaption>
                  </figure>
                </div>
              </section>

              <section className="reveal">
                <div className="mb-6">
                  <span className="text-[11px] tracking-[0.25em] uppercase text-red-500 font-semibold">
                    Galeria
                  </span>
                  <h2 className="text-white text-2xl sm:text-3xl font-bold mt-2">Momentos que ficam</h2>
                  <p className="text-white/50 text-sm mt-2">Toca num vídeo para o ver.</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                  {videos.map((v) => (
                    <figure
                      key={v.id}
                      className="group relative rounded-2xl overflow-hidden border border-white/10 hover:border-red-600/50 bg-neutral-950 transition-colors"
                    >
                      <div className="relative aspect-[9/13] sm:aspect-[3/4]">
                        <video
                          className="absolute inset-0 w-full h-full object-cover"
                          src={v.src}
                          controls
                          playsInline
                          preload="metadata"
                        />
                      </div>
                      <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black via-black/70 to-transparent px-4 pt-8 pb-3">
                        <span className="text-white text-xs sm:text-sm font-medium leading-snug">
                          {v.label}
                        </span>
                      </figcaption>
                    </figure>
                  ))}
                </div>
              </section>

              <section className="reveal">
                <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-gradient-to-br from-red-600/20 via-neutral-900 to-neutral-950 p-8 sm:p-12 text-center">
                  <h2 className="text-white text-2xl sm:text-3xl font-bold">Vem ter connosco</h2>
                  <p className="text-white/60 text-sm sm:text-base mt-3 max-w-md mx-auto leading-relaxed">
                    Não precisas de trazer nada além de ti. Aparece, vais ser bem recebido.
                  </p>
                  <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                      onClick={() => navigateTo('Contacto')}
                      className="rounded-full bg-white hover:bg-white/85 text-black font-semibold px-7 py-3 text-sm transition-colors"
                    >
                      Onde estamos
                    </button>
                    <a
                      href="https://www.instagram.com/angelimaveiro/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded-full border border-white/25 hover:border-white/60 text-white font-semibold px-7 py-3 text-sm transition-colors inline-flex items-center justify-center gap-2"
                    >
                      <img src={instagramIcon} alt="" className="w-4 h-4" />
                      Segue-nos
                    </a>
                  </div>
                </div>
              </section>
            </div>
          </div>
        );
      })(),
    },

    'Reflexão e Ação': {
      title: 'Reflexão e Ação',
      content: (
        <div className="min-h-dvh bg-black py-8 sm:py-12 lg:py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6">
            <div className="text-center mb-8 sm:mb-12">
              <span className="inline-block text-xs uppercase tracking-[0.25em] text-red-500 font-bold mb-2">
                Palavra na Prática
              </span>
              <Title>Reflexão e Ação</Title>
            </div>

            {/* Layout limpo inspirado em "Palavra na Prática" */}
            <div className="reveal bg-white text-black rounded-3xl p-6 sm:p-10 shadow-2xl border-2 border-red-600 relative overflow-hidden">
              <div className="absolute top-4 right-4 flex items-center gap-2 z-20">
                <button
                  onClick={scrapInstagramApify}
                  disabled={loading}
                  title="Atualizar agora"
                  className={`p-2 rounded-full transition-colors ${loading ? 'bg-yellow-100 cursor-not-allowed' : 'bg-gray-100 hover:bg-gray-200'}`}
                >
                  <svg
                    className={`w-4 h-4 text-black ${loading ? 'animate-spin' : ''}`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h5M20 20v-5h-5M5 9a7 7 0 0112-3M19 15a7 7 0 01-12 3" />
                  </svg>
                </button>

                <div className="relative">
                  <button
                    data-popover-btn
                    onClick={(e) => { e.stopPropagation(); setOpenReflectionShare((v) => !v); }}
                    className="p-2 rounded-full bg-gray-100 hover:bg-gray-200"
                    title="Partilhar"
                  >
                    <svg className="w-4 h-4 text-black" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <circle cx="18" cy="5" r="3" strokeWidth="2" />
                      <circle cx="6" cy="12" r="3" strokeWidth="2" />
                      <circle cx="18" cy="19" r="3" strokeWidth="2" />
                      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" strokeWidth="2" />
                      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" strokeWidth="2" />
                    </svg>
                  </button>
                  {openReflectionShare && (
                    <ShareMenu
                      payload={{
                        title: reflection.reference || 'Palavra na Prática - Reflexão e Ação',
                        start: new Date(reflection.postDate || reflection.date),
                        location: 'Igreja Angelim Aveiro',
                        description: reflection.text,
                      }}
                      onClose={() => setOpenReflectionShare(false)}
                    />
                  )}
                </div>
              </div>

              {/* Tag Superior */}
              <div className="flex flex-wrap items-center gap-2 text-xs font-bold uppercase tracking-wider text-red-600 mb-6">
                <span className="px-3 py-1 bg-red-50 text-red-700 rounded-full border border-red-200">
                  Palavra na Prática
                </span>
                {reflection.reference && (
                  <span className="text-gray-600 font-semibold">• {reflection.reference}</span>
                )}
              </div>

              {/* Corpo Principal da Reflexão */}
              <div className="space-y-6">
                <div className="text-gray-800 text-base sm:text-lg leading-relaxed whitespace-pre-wrap break-words font-normal">
                  {reflection.text}
                </div>

                {/* Bloco "Para Hoje" / Ação Prática */}
                <div className="bg-gradient-to-r from-red-50 to-white border-l-4 border-red-600 p-5 rounded-r-2xl mt-8">
                  <h4 className="text-red-700 font-extrabold text-xs sm:text-sm uppercase tracking-wider mb-2 flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-red-600 inline-block"></span>
                    Para Hoje
                  </h4>
                  <p className="text-gray-800 text-sm sm:text-base font-medium leading-relaxed">
                    Não perguntes apenas: "Gostei da Palavra?" Pergunta: "O que vou obedecer por causa dela?" Examina o teu coração e pede a Deus que prepare o solo da tua vida para dar fruto.
                  </p>
                  <p className="mt-3 text-red-700 font-bold text-xs sm:text-sm uppercase tracking-wide border-t border-red-100 pt-3">
                    A Palavra dá fruto quando encontra um coração disponível.
                  </p>
                </div>

                {/* Rodapé da Cartão */}
                <div className="pt-6 border-t border-gray-100 flex flex-col sm:flex-row items-start sm:items-center justify-between text-xs text-gray-500 gap-2">
                  <span className="font-bold text-gray-800 uppercase tracking-wider">Igreja Angelim Aveiro</span>
                  <span className="italic text-gray-600">Conhecer a Cristo e torná-Lo conhecido</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    },

    'Em direto': {
      title: 'Em direto',
      content: (
        <div className="min-h-dvh bg-black text-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
            <div className="text-center mb-8">
              <span className="inline-flex items-center gap-2 rounded-full border border-red-600/40 bg-red-600/10 px-4 py-2 text-sm font-semibold text-red-500">
                <span className="relative flex h-3 w-3">
                  <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75 animate-ping"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600"></span>
                </span>
                AO VIVO
              </span>
              <h1 className="text-4xl sm:text-5xl font-extrabold mt-4">Em direto</h1>
              <p className="text-white/65 mt-3 max-w-2xl mx-auto">
                Não estamos neste momento em direto. Temos transmissões ao vivo todos os domingos de manhã. Veja abaixo o vídeo do último culto.
              </p>
            </div>

            <div className="reveal rounded-3xl overflow-hidden border-2 border-red-600 shadow-2xl bg-neutral-950">
              <div className="aspect-video w-full">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/videoseries?list=UUWHefUk-0T1fpW79gnifYew&rel=0"
                  title="Igreja Angelim Aveiro — transmissão em direto"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://www.youtube.com/@AngelimAveiro/streams"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-full bg-red-600 hover:bg-red-500 px-6 py-3 font-bold transition-colors"
              >
                Ver transmissões no YouTube
              </a>
            </div>
          </div>
        </div>
      ),
    },

    Contacto: {
      title: 'Contacto',
      content: (
        <div className="min-h-dvh bg-black">
          <div className="py-8 sm:py-12 lg:py-16 text-center">
            <Title>Contacto</Title>
            <p className="reveal text-sm sm:text-base text-white max-w-4xl mx-auto px-4">
              Estamos aqui para <span className="text-red-600 font-semibold">acolher, apoiar e caminhar contigo</span>.
            </p>
          </div>
          <div className="py-6 sm:py-8 lg:py-12">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
                <div className="reveal bg-white p-4 sm:p-6 lg:p-8 rounded-2xl sm:rounded-3xl shadow-2xl border-2 border-red-600">
                  <h2 className="text-xl sm:text-2xl font-bold text-black mb-4 sm:mb-6">Informações</h2>
                  <div className="space-y-4 text-black text-sm sm:text-base">
                    <div>
                      <h3 className="text-base sm:text-lg font-semibold text-red-600 mb-2">Endereço</h3>
                      <p>Rua da Quinta do Torto, 28</p>
                      <p>3810-319 Santa Joana, Aveiro</p>
                    </div>
                    <div>
                      <h3 className="text-base sm:text-lg font-semibold text-red-600 mb-2">Horários de Culto</h3>
                      <p> Domingos • 10:30 • Rua da Quinta do Torto, 28 (Aveiro)</p>
                      <p className="mt-2">GC OlÃ / GC OLB • Terças • 20:00</p>
                      <p>GC Eixo • Quartas • 20:00 (Oração) | 20:30 (Adoração e Palavra)</p>
                      <p>GC BOCO • Quintas • 20:00</p>
                      <p>GC LV • Quintas • 20:30</p>
                    </div>
                    <div>
                      <h3 className="text-base sm:text-lg font-semibold text-red-600 mb-2">E-mail</h3>
                      <p>
                        <a href="mailto:angelimaveiro22@gmail.com" className="text-red-600 underline hover:text-black">
                          angelimaveiro22@gmail.com
                        </a>
                      </p>
                    </div>
                    <div className="mt-4">
                      <h3 className="text-base sm:text-lg font-semibold text-red-600 mb-3">Primeira visita?</h3>
                      <p className="leading-relaxed">
                        Serás muito bem-vindo. Prepara-te para ser recebido com amor e carinho pela nossa família.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="reveal bg-white p-4 sm:p-6 lg:p-8 rounded-2xl sm:rounded-3xl shadow-2xl border-2 border-red-600">
                  <h2 className="text-xl sm:text-2xl font-bold text-black mb-4 sm:mb-6">Localização</h2>
                  <div className="w-full rounded-xl sm:rounded-2xl overflow-hidden mb-4">
                    <div className="relative w-full aspect-video">
                      <iframe
                        className="absolute inset-0 w-full h-full"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.7234567890123!2d-8.6291234567890123!3d40.6234567890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDM3JzI0LjQiTiA8wrAzNyc0NC44Ilc!5e0!3m2!1spt!2spt!4v1234567890123!5m2!1spt!2spt"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Localização da Igreja Angelim Aveiro"
                        style={{ border: 0 }}
                      ></iframe>
                    </div>
                  </div>
                  <div className="space-y-3 text-black text-sm">
                    <p>A Igreja Angelim Aveiro está localizada em Santa Joana, Aveiro.</p>
                  </div>
                  <div className="mt-4 sm:mt-6">
                    <a
                      href="https://www.google.com/maps/dir//Rua+da+Quinta+do+Torto,+28,+3810-319+Santa+Joana,+Aveiro"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full sm:w-auto bg-red-600 hover:bg-black text-white px-4 sm:px-6 py-3 rounded-lg transition-colors font-semibold text-sm sm:text-base inline-block text-center"
                    >
                      Obter direções
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  };
  /* --------------------------------------------------------------------------- */

  /* ------------------------------ POPUP GC HOJE ------------------------------ */
  const Popups = () => (
    <>
      {showGcPopup && (
        <div className="fixed inset-0 z-[9991] flex items-end sm:items-center justify-center" aria-modal="true" role="dialog">
          <div className="absolute inset-0 bg-black/80" onClick={() => setShowGcPopup(false)} />
          <div
            className="relative w-full sm:max-w-sm rounded-t-3xl sm:rounded-3xl overflow-hidden shadow-2xl max-h-[92vh] overflow-y-auto"
            style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
          >
            <button
              onClick={() => setShowGcPopup(false)}
              aria-label="Fechar"
              className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-black/60 hover:bg-black/90 text-white flex items-center justify-center text-lg font-bold transition-colors"
            >
              ✕
            </button>
            <img
              src={gcHojeImg}
              alt="GC O Vieira do Bairro, 20:00, Rua Caneira nº25, Vila Verde - OLB"
              className="w-full block"
              draggable={false}
            />
            <div className="bg-black px-4 py-4 flex flex-col gap-2">
              <button
                onClick={() => setShowGcPopup(false)}
                className="w-full text-white/40 hover:text-white/70 text-sm py-1 transition-colors"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
  /* --------------------------------------------------------------------------- */

  return (
    <>
      <VLibras />
      <audio
        ref={audioRef}
        src={fundo}
        autoPlay
        loop
        preload="auto"
        playsInline
        className="hidden"
      />
      {showMenu ? (
        <div
          className="relative w-full h-dvh overflow-hidden bg-black"
          style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        >
          <div className="absolute top-0 w-full h-16 sm:h-20 bg-black z-30"></div>

          <div className="absolute inset-0">
            <video className="w-full h-full object-cover" autoPlay muted loop playsInline>
              <source src={videoBackground} type="video/mp4" />
            </video>
            <div className="absolute inset-0 bg-black bg-opacity-70"></div>
          </div>

          <div
            className="absolute top-2 w-full flex justify-between items-center px-4 sm:px-6 lg:px-8 z-40"
            style={{ paddingTop: 'env(safe-area-inset-top)' }}
          >
            <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16">
              <img
                src={logo}
                alt="Igreja Angelim Aveiro"
                className="w-full h-full object-contain cursor-pointer"
                onClick={goHome}
              />
            </div>
            <div className="text-white text-xs sm:text-sm font-serif italic drop-shadow-lg bg-black bg-opacity-80 px-2 sm:px-3 py-1 rounded border border-red-600">
              @angelimaveiro
            </div>
          </div>

          <div className="relative h-full flex items-center justify-center z-10 pt-16 sm:pt-20 pb-12 sm:pb-16 px-4">
            <div className="w-full max-w-xs sm:max-w-sm mx-auto">
              <div className="p-3 sm:p-4 bg-black bg-opacity-90 border-2 border-red-600 backdrop-blur-sm rounded-lg">
                <div className="text-center mb-3 sm:mb-4">
                  <img
                    src={logo}
                    alt="Igreja Angelim Aveiro"
                    className="w-8 h-8 sm:w-9 sm:h-9 mx-auto mb-1 object-contain cursor-pointer"
                    onClick={goHome}
                  />
                  <h2 className="text-white text-sm sm:text-base font-serif mb-1 text-center">
                    Igreja Angelim Aveiro
                  </h2>
                  <p className="text-red-600 text-xs sm:text-sm font-serif mb-1 text-center italic">
                    @angelimaveiro
                  </p>
                  <p className="text-white text-xs sm:text-sm mb-2">
                    "Conhecer a Cristo e torná-Lo conhecido"
                  </p>
                </div>

                <div className="space-y-1">
                  {menuItems.map((item) => (
                    <div
                      key={item.name}
                      className="text-white hover:text-red-600 cursor-pointer transition-colors group p-2 sm:p-3 hover:bg-black hover:bg-opacity-50 rounded"
                      onClick={() => navigateTo(item.name)}
                    >
                      <div className="flex justify-between items-center">
                        <span className="text-sm sm:text-base group-hover:scale-105 transition-transform font-semibold">
                          {item.name}
                        </span>
                        <svg className="w-4 h-4 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M9 18l6-6-6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                      <span className="text-xs sm:text-sm text-gray-300 group-hover:text-red-400 transition-colors block">
                        {item.description}
                      </span>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-center text-white">
                  <p className="text-xs sm:text-sm text-red-600 font-semibold"> </p>
                </div>
              </div>
            </div>
          </div>

          <div
            className="absolute bottom-2 w-full text-center text-white text-xs z-40"
            style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
          >
            <div className="flex items-center justify-center gap-2">
              <span>© 2026 Igreja Angelim Aveiro</span>
              <span className="text-white/40">•</span>
              <PrivacyPolicy />
            </div>
            <div className="mt-1 opacity-80"></div>
          </div>

          <Popups />

          <Chatbot />
        </div>
      ) : (
        <div
          className="min-h-dvh bg-black"
          style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        >
          <ResponsiveHeader />

          {(pages[activePage]?.content) || (
            <div className="bg-black text-white min-h-dvh">Página não encontrada</div>
          )}

          <footer className={`bg-black ${activePage === 'Jovens' ? 'py-2' : 'py-4 sm:py-6'} border-t-2 border-red-600`}
            style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
              <div className="hidden sm:flex justify-between items-center">
                <div className="text-white text-sm flex items-center gap-2">
                  <span>© 2026 Igreja Angelim Aveiro. Todos os direitos reservados.</span>
                  <span className="text-white/40">•</span>
                  <PrivacyPolicy />
                </div>

                <a
                  href="https://www.instagram.com/angelimaveiro/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-red-600 transition-colors flex items-center space-x-2"
                >
                  <img src={instagramIcon} alt="Instagram" className="w-5 h-5" />
                  <span className="font-medium"></span>
                </a>
              </div>

              <div className="sm:hidden flex flex-col space-y-2">
                <div className="flex justify-center">
                  <a
                    href="https://www.instagram.com/angelimaveiro/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:text-red-600 transition-colors flex items-center space-x-2"
                  >
                    <img src={instagramIcon} alt="Instagram" className="w-5 h-5" />
                    <span className="font-medium"></span>
                  </a>
                </div>
                <div className="text-center text-white text-xs flex items-center justify-center gap-2">
                  <span>© 2026 Igreja Angelim Aveiro. Todos os direitos reservados.</span>
                  <span className="text-white/40">•</span>
                  <PrivacyPolicy />
                </div>
              </div>
            </div>
          </footer>

          <Popups />

          <Chatbot />
        </div>
      )}
    </>
  );
};

export default IgrejaAngelimAveiro;